module.exports = __webpack_public_path__ + "static/media/section15-parkingbuddy.1f2416b8.png";